<template>
  <div class="companiesDetails">
    <div class="box">
      <div class="detail">
        <div class="breadcrumb">
          <el-breadcrumb
            separator-class="el-icon-arrow-right"
            style="display: flex; font-size: 16px"
          >
            <!-- <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item> -->
            <el-breadcrumb-item
              :to="{ path: '/companiesHome' }"
              style="width: 80px"
              >搜企业</el-breadcrumb-item
            >
            <el-breadcrumb-item
              v-if="from_copy !== ''"
              :to="{ path: '/companies' }"
              style="width: 90px"
              >企业列表</el-breadcrumb-item
            >
            <el-breadcrumb-item>{{ com_detail.com_name }}</el-breadcrumb-item>
          </el-breadcrumb>
        </div>

        <div class="box_main">
          <div class="title" id="item000">
            <div style="display: flex; align-items: center; width: 100%">
              <h1 style="font-family: '思源黑体CN'">
                {{ com_detail.com_name }}
              </h1>
            </div>
            <div
              class="sicoriginal"
              style="display: flex; justify-content: flex-end"
            >
              <div
                class="collection"
                style="line-height: 36px; margin-left: 20px; cursor: pointer"
              >
                <el-tooltip content="关注" placement="left" effect="light">
                  <img
                    v-if="coll == 0"
                    @click="collectible(com_detail)"
                    src="../../../../assets/imgs/2.0/_收藏.png"
                    alt=""
                  />
                </el-tooltip>
                <el-popconfirm
                  title="确认取消关注吗？"
                  @confirm="cancel(com_detail)"
                  v-if="coll == 1"
                >
                  <img
                    slot="reference"
                    src="../../../../assets/imgs/2.0/收藏3.png"
                    alt=""
                  />
                </el-popconfirm>
              </div>
            </div>
          </div>
          <div class="box_botton">
            <div class="box_nav">
              <div class="post">
                <div v-for="(item, index) in boxNav" :key="index">
                  <span
                    @click="boxnav(item, index)"
                    :class="[item == naveffect ? 'active' : '']"
                    >{{ item }}</span
                  >
                </div>
              </div>
            </div>
            <div class="box_body" ref="backTop" id="0">
              <div class="txt" id="item00">
                <h2>基本信息</h2>
                <div
                  class="content"
                  v-loading="loading"
                  element-loading-text="数据加载中..."
                  element-loading-spinner="el-icon-loading"
                  element-loading-background="rgba(255, 255, 255, 0.8)"
                >
                  <span v-if="com_detail.legal_person" class="span_css"
                    >法人姓名：{{ com_detail.legal_person }}</span
                  >
                  <span v-if="com_detail.registered_capital" class="span_css"
                    >注册资本：{{
                      com_detail.registered_capital.value +
                      com_detail.registered_capital.unit
                    }}</span
                  >

                  <span v-if="com_detail.start_date" class="span_css"
                    >成立日期：

                    {{ com_detail.start_date }}
                  </span>
                  <span v-if="com_detail.USCO" class="span_css"
                    >统一社会信用代码：{{ com_detail.USCO }}</span
                  >
                  <span v-if="com_detail.address" class="span_brief"
                    ><span class="span_tit"> 地&emsp;&emsp;址：</span>
                    <span class="span_txt">
                      {{ com_detail.address }}
                    </span>
                  </span>
                  <span v-if="com_detail.nature_of_business" class="span_brief"
                    ><span class="span_tit"> 经营范围：</span>
                    <span
                      class="span_txt"
                      style="line-height: 25px; margin: 5px 0 0 0"
                    >
                      {{ com_detail.nature_of_business }}
                    </span>
                  </span>
                </div>
              </div>

              <div class="txt" id="1">
                <h2>司法风险综合报告</h2>
                <div
                  v-loading="loading_"
                  element-loading-text="数据加载中..."
                  element-loading-spinner="el-icon-loading"
                  element-loading-background="rgba(255, 255, 255, 0.8)"
                >
                  <div
                    v-if="report"
                    class="content"
                    style="line-height: 30px; text-indent: 2em"
                    v-html="report"
                  ></div>
                  <div
                    v-if="!report"
                    class="content"
                    style="
                      line-height: 30px;
                      text-indent: 2em;
                      text-align: center;
                    "
                  >
                    <span v-if="!loading_"
                      >当前企业司法风险较低，并无相关文书信息！</span
                    >
                  </div>
                </div>
              </div>
              <div class="txt" id="2">
                <h2>大数据司法风险解析</h2>
                <div
                  class="content"
                  v-loading="loading_chart"
                  element-loading-text="数据加载中..."
                  element-loading-spinner="el-icon-loading"
                >
                  <div class="tag">
                    <el-button-group>
                      <el-button
                        @click="check_chosen(item.label)"
                        :class="chosen_pick == item.label ? 'chosen' : ''"
                        v-for="(item, index) in tag_s"
                        :key="index"
                        >{{ item.name }}</el-button
                      >
                    </el-button-group>
                  </div>
                  <div v-if="show_">
                    <div
                      v-if="chosen_pick == 'CaseReason'"
                      id="CaseReason"
                      style="width: 100%; height: 500px"
                    ></div>
                    <div
                      v-if="chosen_pick == 'DocType'"
                      id="DocType"
                      style="width: 100%; height: 500px"
                    ></div>
                    <div
                      v-if="chosen_pick == 'PlaintiffAndDefendant'"
                      id="PlaintiffAndDefendant"
                      style="width: 100%; height: 500px"
                    ></div>
                    <div
                      v-if="chosen_pick == 'Dispute'"
                      id="Dispute"
                      style="width: 100%; height: 0px"
                    ></div>

                    <div
                      v-if="chosen_pick == 'Level'"
                      id="Level"
                      style="width: 100%; height: 500px"
                    ></div>
                    <div
                      v-if="chosen_pick == 'court'"
                      id="court"
                      style="width: 100%; height: 500px"
                    ></div>
                    <div v-if="!loading_chart">
                      <div
                        v-if="
                          (this.paperCharts_case.length <= 0 &&
                            chosen_pick == 'CaseReason') ||
                          (this.paperwork_type.length <= 0 &&
                            chosen_pick == 'DocType') ||
                          (this.originalDefendant.length <= 0 &&
                            chosen_pick == 'PlaintiffAndDefendant') ||
                          (this.dispute_type.length <= 0 &&
                            chosen_pick == 'Dispute') ||
                          (this.levelList.length <= 0 &&
                            chosen_pick == 'Level') ||
                          (this.dataList.length <= 0 && chosen_pick == 'court')
                        "
                        class="wu_img"
                      >
                        <!-- <img
                        src="../../../../assets/imgs/qiye_img/wu.png"
                        alt=""
                      /> -->
                        <p style="color: #909399; line-height: 50px">
                          暂无数据
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="txt" id="3">
                <h2>裁判文书</h2>
                <div
                  class="content"
                  v-loading="loading__"
                  element-loading-text="数据加载中..."
                  element-loading-spinner="el-icon-loading"
                  element-loading-background="rgba(255, 255, 255, 0.8)"
                >
                  <el-table
                    border
                    :data="tableData"
                    stripe
                    style="width: 100%"
                    :header-cell-style="{ 'text-align': 'center' }"
                  >
                    <!-- :cell-style="{ 'text-align': 'center' }" -->
                    <el-table-column prop="Casename" label="文书名称">
                      <template slot-scope="scope">
                        <el-tooltip
                          class="item"
                          effect="dark"
                          :content="scope.row.Casename"
                          placement="top"
                        >
                          <div class="omit">
                            {{ scope.row.Casename }}
                          </div>
                        </el-tooltip>
                      </template>
                    </el-table-column>
                    <el-table-column
                      prop="DocType"
                      label="文书类型"
                      width="100"
                      align="center"
                    >
                    </el-table-column>
                    <el-table-column
                      prop="RefereeDate"
                      label="审理日期"
                      width="100"
                      align="center"
                    >
                    </el-table-column>

                    <el-table-column
                      prop="Court"
                      align="center"
                      label="法院级别"
                      width="180"
                    >
                      <template slot-scope="scope">
                        <span>{{ scope.row.Court.name }}</span>
                      </template>
                    </el-table-column>
                    <el-table-column
                      prop="TrialPro"
                      label="审理程序"
                      width="100"
                      align="center"
                    >
                    </el-table-column>
                    <el-table-column
                      prop="TrialPro"
                      label="案件身份"
                      width="180"
                      align="center"
                    >
                      <template slot-scope="scope">
                        <div
                          v-for="(item, index) in scope.row.Party"
                          :key="index"
                          class="omit_"
                        >
                          <span v-if="item.name == com_detail.com_name">
                            <span
                              v-if="item.type !== null && item.type !== ''"
                              >{{ item.type }}</span
                            >
                            <span v-else> -- </span>

                            <!-- <span v-if="item.type !== ''"> -- </span
                            >{{ item.name }} -->
                          </span>
                        </div>
                      </template>
                    </el-table-column>
                    <el-table-column
                      prop="operate"
                      width="80"
                      label="操作"
                      fixed="right"
                      align="center"
                    >
                      <template slot-scope="scope">
                        <router-link
                          :to="{
                            path: `/detail/${scope.row._id}`,
                            query: { keyword: '', type: '2' },
                          }"
                          target="_blank"
                        >
                          <el-button type="text">查看</el-button>
                        </router-link>
                      </template>
                    </el-table-column>
                  </el-table>
                  <div class="page-bar" v-if="totalCount > 5">
                    <el-pagination
                      background
                      layout="prev, pager, next"
                      :total="totalCount > 10000 ? 10000 : totalCount"
                      @current-change="handleCurrentChange"
                      :current-page.sync="parameter.page"
                      :page-size="5"
                    >
                    </el-pagination>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <ComFooter></ComFooter>
  </div>
</template>

<script>
import echarts from "echarts";

import china from "echarts/map/json/china.json";
echarts.registerMap("china", china);
import store from "@/store";
import $ from "jquery";
import ComFooter from "../../../../components/ComFooter.vue";
export default {
  data() {
    return {
      com_detail: {},
      coll: 1, //收藏判断
      report: "",
      boxNav: [
        "基本信息",
        "司法风险综合报告",
        "大数据司法风险解析",
        "裁判文书",
      ],
      naveffect: null,
      parameter: {
        page: 1,
        size: 5,
      },
      tableData: [],
      totalCount: 0,
      tag_s: [
        {
          name: "案由统计",
          label: "CaseReason",
        },
        {
          name: "文书类型",
          label: "DocType",
        },
        {
          name: "原被告统计",
          label: "PlaintiffAndDefendant",
        },
        {
          name: "纠纷对象",
          label: "Dispute",
        },
        {
          name: "审理级别",
          label: "Level",
        },

        {
          name: "案件归属地",
          label: "court",
        },
      ],
      chosen_pick: "CaseReason",

      paperCharts_case: [], //案由图表数据
      paperwork_type: [], //文书类型-类别
      paperwork_count: [], //文书类型-数量
      originalDefendant: [], //原被告统计
      dispute_type: [], //纠纷对象-类别
      dispute_count: [], //纠纷对象-数量
      levelList: [], //审理级别
      dataList: [], //归属地
      show_: true,
      max_map: 0,
      loading: true,
      loading_chart: false,
      loading_: false,
      loading__: false,
      from_copy: "",
    };
  },
  created() {
    // console.log(this.$route.query.form);
    window.sessionStorage.setItem("enterprise_search", this.$route.query.form);
    this.from_copy = this.$route.query.form;
    this.caseDetail();
    this.caseList();
    this.detail_sfx();
    this.chart_s();
  },
  methods: {
    detail_sfx() {
      this.loading_ = true;
      this.$http
        .get("/com_detail_sfxx?_id=" + this.caseId)
        .then((res) => {
          console.log(res);
          if (res.data.code == 200) {
            this.report = res.data.data.judicial_risk;
          }
          this.loading_ = false;

          // return
        })
        .catch((rer) => {
          console.log(rer);
        });
    },
    chart_s() {
      this.loading_chart = true;
      this.$http
        .get("/com_detail_charts?_id=" + this.caseId)
        .then((res) => {
          console.log(res);
          // 案由图表数据处理
          this.paperCharts_case = [];
          res.data.data.charts.CaseReason.forEach((item) => {
            let paper_case = {
              value: item.doc_count,
              name: item.key,
            };
            this.paperCharts_case.push(paper_case);
          });
          // 文书类型
          this.paperwork_type = []; //文书类型-类别
          this.paperwork_count = []; //文书类型-数量;
          res.data.data.charts.DocType.forEach((item) => {
            this.paperwork_type.push(item.key); //文书类型-类别
            this.paperwork_count.push(item.doc_count);
          });

          // 原被告统计
          this.originalDefendant = [];
          for (var i in res.data.data.charts.PlaintiffAndDefendant) {
            if (res.data.data.charts.PlaintiffAndDefendant[i].value > 0) {
              let Plaintiff_Defendant = {
                value: res.data.data.charts.PlaintiffAndDefendant[i].value,
                name: res.data.data.charts.PlaintiffAndDefendant[i].key,
              };
              this.originalDefendant.push(Plaintiff_Defendant);
            }
          }

          // 纠纷对象
          this.dispute_type = []; //纠纷对象-类别
          this.dispute_count = []; //纠纷对象-数量;
          res.data.data.charts.Dispute.company.forEach((item) => {
            this.dispute_type.push(item.key); //纠纷对象-类别
            this.dispute_count.push(item.doc_count);
          });

          //审理级别
          this.levelList = [];
          res.data.data.charts.Level.forEach((item) => {
            let level = {
              value: item.doc_count,
              name: item.key,
            };
            this.levelList.push(level);
          });

          // 地区
          this.dataList = res.data.data.charts.court;
          this.dataList.forEach((item, index) => {
            this.dataList[index].value = this.dataList[index].count;
            if (this.max_map < item.count) {
              this.max_map = this.ceilNumber(item.count);
            }
          });
          // console.log(this.ceilNumber(495));
          this.$nextTick(function () {
            this.myBriefs();
            this.loading_chart = false;
          });
          // return
        })
        .catch((rer) => {
          console.log(rer);
        });
    },
    reload_() {
      this.show_ = false;
      this.$nextTick(function () {
        this.show_ = true;
        // console.log('this.show_')
      });
    },
    check_chosen(label) {
      this.chosen_pick = label;
      //
      this.$nextTick(function () {
        if (label == "CaseReason") {
          this.myBriefs();
        } else if (label == "DocType") {
          this.DocType();
        } else if (label == "PlaintiffAndDefendant") {
          this.PlaintiffAndDefendant();
        } else if (label == "Dispute") {
          this.Dispute();
        } else if (label == "Level") {
          this.Level();
        } else if (label == "court") {
          this.court();
        }
        // this.reload_();
      });
    },
    caseDetail() {
      this.loading = true;
      this.caseId = this.$route.params.id;
      // console.log(this.caseId);
      window.scrollTo(0, 0);
      this.$http
        .get("/com_detail?_id=" + this.caseId)
        .then((res) => {
          console.log(res);
          this.com_detail = res.data.data;
          this.coll = this.com_detail.coll;
          this.loading = false;
          return;

          // if (this.report == "") {
          //   this.boxNav = ["基本信息", "大数据司法风险解析", "裁判文书"];
          // }
        })
        .catch((rer) => {
          console.log(rer);
        });
    },
    caseList() {
      this.loading__ = true;
      this.$http
        .get(
          "/com_detail_case?_id=" +
            this.caseId +
            "&page=" +
            this.parameter.page +
            "&size=" +
            this.parameter.size
        )
        .then((res) => {
          console.log(res);
          // return
          if (res.data.data.total) {
            this.tableData = res.data.data.data;
            this.totalCount = res.data.data.total;
          }
          this.loading__ = false;
        })
        .catch((rer) => {
          console.log(rer);
        });
    },
    // 向上取整十，整百，整千，整万
    ceilNumber(number) {
      let bite = 0;
      if (number < 10) {
        return 10;
      }
      while (number >= 10) {
        number /= 10;
        bite += 1;
      }
      return Math.ceil(number) * Math.pow(10, bite);
    },
    handleCurrentChange(val) {
      this.parameter.page = val;
      this.caseList();
    },
    // 企业收藏
    collectible(row) {
     
      let collOne = {
        // user_id: store.getCookie("user_id"),
        docid: row._id,
        // role: store.getCookie("role"),
        doctype: 4,
        docname: row.com_name,
      };
      this.$http
        .post("/coll", collOne)
        .then((res) => {
          console.log(res);
          this.$message({
            message: "关注成功",
            type: "success",
          });
          this.coll=1
          // this.caseDetail();
        })
        .catch((error) => {
          console.log(error);
        });
    },
    // 取消企业收藏
    cancel(row) {
      let collOne = {
        docid: row._id,
      };
      this.$http
        .post("/delcoll", collOne)
        .then((res) => {
          console.log(res);
          this.$message({
            message: "取消关注成功",
            type: "success",
          });
          this.coll=0

          // this.caseDetail();
        })
        .catch((error) => {
          console.log(error);
        });
    },

    //
    boxnav(a, b) {
      // console.log(a, b);
      this.naveffect = a;
      $("html, body").animate({ scrollTop: $("#" + b).offset().top - 81 });
    },
    // 案由统计
    myBriefs() {
      if (this.paperCharts_case.length <= 0) {
        window.document.getElementById("CaseReason").style.height = "0px";
      } else {
        window.document.getElementById("CaseReason").style.height = "500px";
      }
      var myBrief = this.$echarts.init(
        window.document.getElementById("CaseReason")
      );
      //配置图表
      var option = {
        title: {
          //   text: "Referer of a Website",
          //   subtext: "Fake Data",
          //   left: "center",
        },
        tooltip: {
          trigger: "item",
        },
        legend: {
          x: "center",
          y: "bottom",
        },
        series: [
          {
            type: "pie",
            radius: ["40%", "70%"],
            label: {
              normal: {
                formatter: "{b}({d}%)", //模板变量有 {a}、{b}、{c}、{d}，分别表示系列名，数据名，数据值，百分比。{d}数据会根据value值计算百分比
              },
            },
            data: this.paperCharts_case,
          },
        ],
      };
      myBrief.setOption(option, true);
    },
    // 文书类型
    DocType() {
      if (this.paperwork_type.length <= 0) {
        window.document.getElementById("DocType").style.height = "0px";
      } else {
        window.document.getElementById("DocType").style.height = "500px";
      }
      var DocType_ = this.$echarts.init(
        window.document.getElementById("DocType")
      );
      //配置图表
      var option = {
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "shadow",
          },
        },

        grid: {
          left: "15%",
          // bottom:"35%"
        },
        xAxis: {
          type: "value",

          boundaryGap: [0, 0.01],
        },
        yAxis: {
          show: true,
          boundaryGap: true,
          type: "category",
          data: this.paperwork_type,
        },
        series: [
          {
            type: "bar",
            data: this.paperwork_count,
            showBackground: true,
            backgroundStyle: {
              color: "rgba(180, 180, 180, 0.2)",
            },
            // barWidth: 30, // 柱图宽度
            barMaxWidth: 30, // 最大宽度
            label: {
              //设置柱状图上显示  对应值
              show: true,
              position: "right",
              color: "#606266",
            },
            itemStyle: {
              normal: {
                color: function (params) {
                  // 设置前三个颜色不一样
                  var num = params.value;
                  var djg = params.dataIndex; //第几个数
                  var retcoler = "#345edc";
                  if (djg > 9) {
                    retcoler = "#ef6b59";
                  }
                  return retcoler;
                },
                // barBorderRadius: [0, 8, 8, 0], // 设置柱状图圆角（顺时针左上，右上，右下，左下）
              },
            },
          },
        ],
      };
      DocType_.setOption(option, true);
    },
    // 原被告统计
    PlaintiffAndDefendant() {
      console.log(this.chosen_pick);
      if (this.originalDefendant.length <= 0) {
        window.document.getElementById("PlaintiffAndDefendant").style.height =
          "0px";
      } else {
        window.document.getElementById("PlaintiffAndDefendant").style.height =
          "500px";
      }
      // console.log(this.originalDefendant);
      var PlaintiffAndDefendant_ = this.$echarts.init(
        window.document.getElementById("PlaintiffAndDefendant")
      );
      //配置图表
      var option = {
        title: {
          //   text: "Referer of a Website",
          //   subtext: "Fake Data",
          //   left: "center",
        },
        tooltip: {
          trigger: "item",
        },
        legend: {
          x: "center",
          y: "bottom",
        },
        series: [
          {
            type: "pie",
            radius: ["40%", "70%"],
            label: {
              normal: {
                formatter: "{b}({d}%)", //模板变量有 {a}、{b}、{c}、{d}，分别表示系列名，数据名，数据值，百分比。{d}数据会根据value值计算百分比
              },
            },
            data: this.originalDefendant,
          },
        ],
      };
      PlaintiffAndDefendant_.setOption(option, true);
    },
    // 纠纷对象
    Dispute() {
      console.log();
      if (this.dispute_type.length <= 0) {
        window.document.getElementById("Dispute").style.height = "0px";
        // window.document.getElementById("Dispute").style.display = "none";
        this.reload_();
      } else {
        window.document.getElementById("Dispute").style.height = "500px";
        //  window.document.getElementById("Dispute").style.display = "block";
      }
      var Dispute_ = this.$echarts.init(
        window.document.getElementById("Dispute")
      );
      //配置图表
      var option = {
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "shadow",
          },
        },

        grid: {
          left: "15%",
          // bottom:"35%"
        },
        xAxis: {
          type: "value",

          boundaryGap: [0, 0.01],
        },
        yAxis: {
          show: true,
          boundaryGap: true,
          type: "category",
          data: this.dispute_type,
          axisLabel: {
            show: true,
            interval: 0,
            textStyle: {
              fontSize: "12",
              letterSpacing: "2",
            },
            formatter: function (params) {
              var newParamsName = "";
              var paramsNameNumber = params.length;
              var provideNumber = 10; //一行显示几个字
              var rowNumber = Math.ceil(paramsNameNumber / provideNumber);
              if (paramsNameNumber > provideNumber) {
                for (var p = 0; p < rowNumber; p++) {
                  var tempStr = "";
                  var start = p * provideNumber;
                  var end = start + provideNumber;
                  if (p == rowNumber - 1) {
                    tempStr = params.substring(start, paramsNameNumber);
                  } else {
                    tempStr = params.substring(start, end) + "\n";
                  }
                  newParamsName += tempStr;
                }
              } else {
                newParamsName = params;
              }
              return newParamsName;
            },
          },
        },
        series: [
          {
            type: "bar",
            data: this.dispute_count,
            showBackground: true,
            backgroundStyle: {
              color: "rgba(180, 180, 180, 0.2)",
            },
            // barWidth: 30, // 柱图宽度
            barMaxWidth: 30, // 最大宽度
            label: {
              //设置柱状图上显示  对应值
              show: true,
              position: "right",
              color: "#606266",
            },
            itemStyle: {
              normal: {
                color: function (params) {
                  // 设置前三个颜色不一样
                  var num = params.value;
                  var djg = params.dataIndex; //第几个数
                  var retcoler = "#345edc";
                  if (djg > 9) {
                    retcoler = "#ef6b59";
                  }
                  return retcoler;
                },
                // barBorderRadius: [0, 8, 8, 0], // 设置柱状图圆角（顺时针左上，右上，右下，左下）
              },
            },
          },
        ],
      };
      Dispute_.setOption(option, true);
    },
    // 审理级别
    Level() {
      if (this.levelList.length <= 0) {
        window.document.getElementById("Level").style.height = "0px";
      } else {
        window.document.getElementById("Level").style.height = "500px";
      }
      var Level_ = this.$echarts.init(window.document.getElementById("Level"));
      //配置图表
      var option = {
        title: {
          //   text: "Referer of a Website",
          //   subtext: "Fake Data",
          //   left: "center",
        },
        tooltip: {
          trigger: "item",
        },
        legend: {
          x: "center",
          y: "bottom",
        },
        series: [
          {
            type: "pie",
            radius: ["40%", "70%"],
            label: {
              normal: {
                formatter: "{b}({d}%)", //模板变量有 {a}、{b}、{c}、{d}，分别表示系列名，数据名，数据值，百分比。{d}数据会根据value值计算百分比
              },
            },
            data: this.levelList,
          },
        ],
      };
      Level_.setOption(option, true);
    },
    // 案件归属地
    court() {
      if (this.dataList.length <= 0) {
        window.document.getElementById("court").style.height = "0px";
      } else {
        window.document.getElementById("court").style.height = "500px";
      }
      var court_map = this.$echarts.init(
        window.document.getElementById("court")
      );
      var option = {
        tooltip: {
          trigger: "item",

          confine: true,
        },

        visualMap: {
          //地图图例
          show: true,
          left: 26,
          bottom: 40,
          showLabel: true,
          pieces: [
            //根据数据大小，各省显示不同颜色
            {
              gte: 100000,
              label: ">= 100000",
              color: "#1f307b",
            },
            {
              gte: 50000,
              lt: 99900,
              label: "50000 - 99900",
              color: "#3c57ce",
            },
            {
              gte: 10000,
              lt: 49900,
              label: "10000 - 49900",
              color: "#6f83db",
            },
            {
              gte: 1000,
              lt: 9900,
              label: "1000 - 9900",
              color: "#9face7",
            },
            {
              lt: 1000,
              label: "<1000",
              color: "#bcc5ee",
            },
          ],
        },

        geo: {
          //中国地图设置
          map: "china",
          scaleLimit: {
            min: 1,
            max: 2,
          },
          zoom: 1,
          // top: 120,
          label: {
            normal: {
              show: true,
              fontSize: "14",
              color: "rgba(0,0,0,0.7)",
            },
          },
          roam: true,
          itemStyle: {
            normal: {
              borderColor: "rgba(0, 0, 0, 0.2)",
            },
            emphasis: {
              areaColor: "#f2d5ad",
              shadowOffsetX: 0,
              shadowOffsetY: 0,
              borderWidth: 0,
            },
          },
        },
        series: [
          {
            name: "地域",
            type: "map",
            geoIndex: 0,
            data: this.dataList,
          },
        ],
        visualMap: {
          min: 0,
          max: this.max_map,
          splitNumber: 10,
          inverse: false,
          orient: "horizontal",
          align: "auto",
          realtime: false,
          calculable: true,
          precision: 0,
          left: "center",
          itemHeight: 300,
          // text:['10000000 篇', '0篇'],
          inRange: {
            color: ["#7bb5e4", "#3463bb", "#0b3068"],
          }, //设置颜色
        },
      };
      court_map.setOption(option, true);
    },
  },
  components: {
    ComFooter,
  },
};
</script>

<style lang="less" scoped>
.companiesDetails {
  background: rgb(245, 239, 228);
  min-width: 1280px;
  .box {
    width: 100%;
    background: url("../../../../assets/imgs/raphael-schaller-GkinCd2enIY-unsplash.png");
    background-size: 100% 1000px;
    margin: auto;
    .detail {
      width: 80%;
      // width: calc(80% - 150px);
      //   min-width: 1280px;
      max-width: 1280px;
      margin: auto;
      padding: 10px 20px 20px 20px;
      min-height: calc(100vh - 210px);
    }
  }
}
.detail {
  // min-width: 1100px;
  width: 80%;
  // width: 52.5%;
  // max-width: 1260px;

  margin: 0 auto;

  // padding: 0 18%;
  .breadcrumb {
    margin: 10px 0 20px 45px;
    height: 36px;
    line-height: 36px;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  .title {
    background: #ffffff;
    margin-left: 36px;
    padding: 10px;
    // border-radius: 10px;
    border-top-left-radius: 10px;
    border-top-right-radius: 10px;
    // width: 100%;

    h1 {
      width: 100%;
      font-size: 21px;
      font-weight: 600;
      line-height: 60px;
      text-align: center !important;
      // margin-bottom: 20px;
      display: inline-block;
      //
    }
    p {
      margin-bottom: 10px;
      span {
        margin-right: 30px;
        // font-family: ;
      }
    }
  }
  .box::-webkit-scrollbar {
    // display: none;
  }
  .box_botton {
    // position: relative;
    // margin-top: 30px;
    // width: 1280px;

    .box_nav {
      // width: 300px;
      // position: absolute;
      // left: -300px;
      // width: 130px;
      float: left;
      position: relative;
      left: -150px;
      top: -80px;
      font-size: 16px;
      // top: -110px;
      // height: 800px;
      // position: fixed !important;
      // position:absolute !important;
      // left: 0px;
      // top: 180px;
      // border-right: 2px solid rgb(134, 134, 134);
      .post {
        position: fixed;
        span {
          height: 36px;
          line-height: 36px;
          padding-right: 20px;
          display: block;
          text-align: right;
          border-right: 2px solid rgb(134, 134, 134);
          cursor: pointer;
        }
      }
    }
    .box_body {
      // margin-left: 36px;
      background: #ffffff;
      border-bottom-left-radius: 10px;
      border-bottom-right-radius: 10px;
      // border-radius: 10px;
      margin: 0px 0 20px 36px;
      .box00 {
        // position: absolute;
        /deep/ a {
          color: #88adff !important;
        }
        padding: 10px 0;

        /deep/ span {
          // display: inline-block;
          // margin: 20px 0;
        }
        /deep/ div {
          // width: 1000px;
          margin: 0 20px;
          padding: 0px 20px;
          text-indent: 2em;
          background: #f8f7f6;
        }
      }
      .txt {
        padding-bottom: 10px;
        padding-top: 10px;
        margin-bottom: 20px;
        h2 {
          padding-left: 10px;
          font-size: 18px;
          font-weight: 600;
          border-left: 3px solid #fad60c;
        }
        .content {
          border-radius: 10px;
          background: #f8f7f6;
          margin: 20px;
          padding: 10px 30px;
          font-size: 16px;
          .span_css {
            min-width: 50%;
            display: inline-block;
            height: 36px;
            line-height: 36px;
          }
          .span_brief {
            min-width: 100%;
            display: inline-block;
            // height: 36px;
            line-height: 36px;
            // line-height: 36px;

            .hover_brief {
              cursor: pointer;
              color: rgb(59, 156, 247);
            }
            .hover_brief:hover {
              color: rgb(94, 173, 248);
            }

            display: flex;
            .span_tit {
              display: inline-block;
              width: 80px;
            }
            .span_txt {
              width: 90%;
              display: inline-block;
            }
            .hover_brief_word:hover {
              // cursor: pointer;
              // color: rgb(94, 173, 248);
            }
          }
        }
      }
    }
  }
}
.collection {
  position: relative;
  top: 3px;
  img {
    width: 28px;
  }
}
.active {
  color: rgb(0, 0, 0);
  font-weight: 900;
  border-right: 2px solid rgb(0, 0, 0) !important;
}
.omit {
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}
.omit_ {
  white-space: nowrap;
  display: inline;
}
.page-bar {
  margin: 10px 0;
  display: flex;
  justify-content: center;
}
.chosen {
  color: #000000;
  background: #faf1ea;
  border-color: #ddb361;
}
.tag {
  padding: 20px;
  display: flex;
  justify-content: center;
  align-items: center;
  .el-button {
    color: #000000;
    border: 1px solid #ddb361;
  }
  .el-button:hover {
    color: #ddb361;
    background: #faf1ea;
    border-color: #ddb361;
  }
}
.wu_img {
  text-align: center;
  img {
    // width: 200px;
  }
  p {
    // text-align: center;
  }
}
</style>